import {createAsyncThunk} from "@reduxjs/toolkit";
import {AxiosResponse} from "axios";
import instance from "@/config/axios";
import { serializeQueryParam } from '@/utils'

export const getCouponList = createAsyncThunk('coupon/getCouponList',
	async ({statusMeta, venueMeta, searchMeta, pageMeta, sortMeta, sizeMeta}: CouponListQuery) => {
		const url = `v1/coupons${serializeQueryParam({venueId: venueMeta, status: statusMeta, search: searchMeta, sortBy: sortMeta, page: pageMeta, size: sizeMeta})}`
		const response: AxiosResponse<Coupon> = await instance.get(url)
		const summaryResponse: AxiosResponse<CouponSummary> = await instance.get(`v1/coupons/status-summary${serializeQueryParam({ venueId: venueMeta, search: searchMeta })}`)
		const coupons = {
			items: response.data.items,
			meta: response.data.paging,
			summary: summaryResponse.data
		} as CouponState

		return coupons
	})

export const getActiveCouponList = createAsyncThunk('coupon/getActiveCouponList',
	async ({ quotaMeta, venueMeta }: ActiveCouponListQuery) => {
		const url = `v1/coupons/active${serializeQueryParam({remainingQuota: quotaMeta, venueId: venueMeta})}`
		const response: AxiosResponse<Coupon> = await instance.get(url)

		const coupons = {
			items: response.data.items,
			meta: response.data.paging,
		} as CouponState

		return coupons
	})


export const createCoupon = createAsyncThunk('coupon/createCoupon',
	async (data: Coupon) => {
		const response: AxiosResponse<CouponState> = await instance.post('v1/coupons', data)
		return response.data
	})

export const editCoupon = createAsyncThunk('coupon/editCoupon',
	async ({ data, id }: { data: Coupon, id: string }) => {
		const response: AxiosResponse<CouponState> = await instance.put(`v1/coupons/${id}`, data)
		return response.data
	})
